import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { SCHEDULED_MESSAGE_TYPES } from 'src/constants/messages';
import { addNotification } from 'src/actions/notificationActions';

export const GET_SCHEDULED_MESSAGES = '@scheduled-messages/get-scheduled-messages';
export const GET_SCHEDULED_MESSAGES_SUCCESS = '@scheduled-messages/get-scheduled-messages-success';
export const GET_SCHEDULED_MESSAGES_ERROR = '@scheduled-messages/get-scheduled-messages-error';
export const SET_SCHEDULED_MESSAGES = '@scheduled-messages/clear-scheduled-messages';

export const REMOVE_SCHEDULED_MESSAGES = '@scheduled-messages/remove-scheduled-messages';
export const REMOVE_SCHEDULED_MESSAGES_SUCCESS = '@scheduled-messages/remove-scheduled-messages-success';
export const REMOVE_SCHEDULED_MESSAGES_ERROR = '@scheduled-messages/remove-scheduled-messages-error';

export const REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE = '@scheduled-messages/replace-system-gen-scheduled-message';
export const REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE_SUCCESS = '@scheduled-messages/replace-system-gen-scheduled-message-success';
export const REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE_ERROR = '@scheduled-messages/replace-system-gen-scheduled-message-error';

export const GET_FOLLOW_UP_MESSAGES = '@scheduled-messages/get-follow-up-messages';
export const GET_FOLLOW_UP_MESSAGES_SUCCESS = '@scheduled-messages/get-follow-up-messages-success';
export const GET_FOLLOW_UP_MESSAGES_ERROR = '@scheduled-messages/get-follow-up-messages-error';

export const ADD_CONTACTS_SCHEDULED_MESSAGES = '@scheduled-messages/add-contacts-scheduled-messages';
export const ADD_CONTACTS_SCHEDULED_MESSAGES_SUCCESS = '@scheduled-messages/add-contacts-scheduled-messages-success';
export const ADD_CONTACTS_SCHEDULED_MESSAGES_ERROR = '@scheduled-messages/add-contacts-scheduled-messages-error';

export const UPDATE_CONTACTS_SCHEDULED_MESSAGES = '@scheduled-messages/update-contacts-scheduled-messages';
export const UPDATE_CONTACTS_SCHEDULED_MESSAGES_SUCCESS = '@scheduled-messages/update-contacts-scheduled-messages-success';
export const UPDATE_CONTACTS_SCHEDULED_MESSAGES_ERROR = '@scheduled-messages/update-contacts-scheduled-messages-error';

export const REMOVE_CONTACTS_SCHEDULED_MESSAGES = '@scheduled-messages/remove-contacts-scheduled-messages';
export const REMOVE_CONTACTS_SCHEDULED_MESSAGES_SUCCESS = '@scheduled-messages/remove-contacts-scheduled-messages-success';
export const REMOVE_CONTACTS_SCHEDULED_MESSAGES_ERROR = '@scheduled-messages/remove-contacts-scheduled-messages-error';

export const SET_SCHEDULED_MESSAGES_QUERY = '@scheduled-messages/set-scheduled-messages-query';
export const CLEAR_SCHEDULED_MESSAGES_QUERY_FILTER = '@scheduled-messages/clear-scheduled-messages-query-filter';

export const SET_SELECTED_SCHEDULED_MESSAGES = '@scheduled-messages/set-selected-scheduled-messages';

export const SET_VALUES_FORM_SEND_TEXT = '@scheduled-messages/set-values-form-send-text';

export const SEND_TEXT_MESSAGE = '@scheduled-messages/send-text-message';
export const SEND_TEXT_MESSAGE_SUCCESS = '@scheduled-messages/send-text-message-success';
export const SEND_TEXT_MESSAGE_ERROR = '@scheduled-messages/send-text-message-error';

export const SET_BACK_TO_SCHEDULED_MESSAGES_LIST = '@scheduled-messages/set-back-to-scheduled-messages-list';
export const SET_BACK_TO_SCHEDULED_MESSAGE_EDIT = '@scheduled-messages/set-back-to-scheduled-message-edit';
export const SET_SCHEDULED_MESSAGE_DETAILS_TAB = '@scheduled-messages/set-scheduled-message-details-tab';

export const GET_SCHEDULED_MESSAGE_CONTACTS = '@scheduled-messages/get-scheduled-message-contacts';
export const GET_SCHEDULED_MESSAGE_CONTACTS_SUCCESS = '@scheduled-messages/get-scheduled-message-contacts-success';
export const GET_SCHEDULED_MESSAGE_CONTACTS_ERROR = '@scheduled-messages/get-scheduled-message-contacts-error';

export const CLEAR_SCHEDULED_MESSAGE_CONTACTS = '@scheduled-messages/clear-scheduled-message-contacts';

export const SET_CONTACTS_SEND_TO_QUERY = '@scheduled-messages/set-contacts-send-to-query';
export const SET_CONTACTS_DONT_SEND_TO_QUERY = '@scheduled-messages/set-contacts-dont-send-to-query';
export const SET_SELECTED_CONTACTS_SEND_TO = '@scheduled-messages/set-selected-contacts-send-to';
export const SET_SELECTED_CONTACTS_DONT_SEND_TO = '@scheduled-messages/set-selected-contacts-dont-send-to';

export const SOCKET_SCHEDULED_MESSAGE_SENT_LIST = '@scheduled-messages/socket-scheduled-message-sent-list';

export const GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY = '@scheduled-messages/get-scheduled-message-contacts-summary';
export const GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY_SUCCESS = '@scheduled-messages/get-scheduled-message-contacts-summary-success';
export const GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY_ERROR = '@scheduled-messages/get-scheduled-message-contacts-summary-error';

export const getScheduledMessages = () => async (dispatch, getState) => {
  dispatch({
    type: GET_SCHEDULED_MESSAGES,
  });
  try {
    const query = getState()?.scheduledMessages?.query || {};
    const params = {
      page: query?.page,
      pageSize: query?.pageSize,
      q: query?.search ? query.search : undefined,
      status: query?.status,
      messageType: query?.filters?.messageType?.value,
      dateFrom: query?.filters?.dateFrom,
      dateTo: query?.filters?.dateTo,
      eventsToSelect: query?.filters?.eventsToSelect?.length > 0 ? query.filters.eventsToSelect.map((event) => event.value || event).join(',') : undefined,
      groupsToSelect: query?.filters?.groupsToSelect?.length > 0 ? query.filters.groupsToSelect.map((group) => group.value || group).join(',') : undefined,
      sort: query?.sort,
    };

    const response = await axios.get('/api/scheduledMessages', { params });
    dispatch({
      type: GET_SCHEDULED_MESSAGES_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_SCHEDULED_MESSAGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_SCHEDULED_MESSAGES_ERROR,
    });
  }
};

export const removeScheduledMessages = (messages = [], doWhenTry = false, doWhenCatch = false, options = null) => async (dispatch) => {
  const {
    stopSending,
  } = options || {};
  dispatch({
    type: REMOVE_SCHEDULED_MESSAGES,
  });
  try {
    const response = await axios.delete('/api/scheduledMessages', {
      data: { messages },
    });
    const {
      success: isSuccess,
      isScheduledBirthdayMessage,
      isScheduledGroupSmartActionMessage,
      isScheduledEventSmartActionMessage,
      isScheduledOrderFollowUpMessage,
      isScheduledMessage,
    } = response?.data || {};

    const isScheduledBirthdayMessageAndAnother = !!(
      isScheduledBirthdayMessage
      && (
        isScheduledGroupSmartActionMessage
        || isScheduledEventSmartActionMessage
        || isScheduledOrderFollowUpMessage
        || isScheduledMessage
      )
    );

    if (!isSuccess) {
      dispatch(addNotification(REMOVE_SCHEDULED_MESSAGES_ERROR, `Cannot ${stopSending ? 'stop' : 'delete'} selected messages`, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: REMOVE_SCHEDULED_MESSAGES_ERROR,
      });
      return;
    }

    let successMessage = `Selected messages have been successfully ${
      stopSending ? 'stopped' : 'deleted'
    }${
      isScheduledBirthdayMessageAndAnother ? '. The birthday messages have been rescheduled for next year.' : ''
    }`;

    if (isScheduledBirthdayMessage && !isScheduledBirthdayMessageAndAnother) {
      successMessage = 'The selected messages have been rescheduled for next year.';
    }

    dispatch(addNotification(
      REMOVE_SCHEDULED_MESSAGES_SUCCESS,
      successMessage,
      NOTIFICATION_STATUS.SUCCESS
    ));
    dispatch({
      type: REMOVE_SCHEDULED_MESSAGES_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(REMOVE_SCHEDULED_MESSAGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: REMOVE_SCHEDULED_MESSAGES_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const addContactsScheduledMessage = (messageId, contacts, doWhenTry, doWhenCatch) => async (dispatch) => {
  dispatch({
    type: ADD_CONTACTS_SCHEDULED_MESSAGES,
  });
  try {
    await axios.post(
      `/api/scheduledMessages/${messageId}/contacts`,
      {
        contacts,
      }
    );
    dispatch({
      type: ADD_CONTACTS_SCHEDULED_MESSAGES_SUCCESS,
    });
    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(ADD_CONTACTS_SCHEDULED_MESSAGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: ADD_CONTACTS_SCHEDULED_MESSAGES_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateContactsScheduledMessage = (messageId, type, sendTo, contacts, doWhenTry, doWhenCatch) => async (dispatch) => {
  dispatch({
    type: UPDATE_CONTACTS_SCHEDULED_MESSAGES,
  });
  try {
    let url = type === SCHEDULED_MESSAGE_TYPES.SCHEDULED_MESSAGE
      || type === SCHEDULED_MESSAGE_TYPES.GROUP_SMART_ACTION_MESSAGE
      ? `/api/scheduledMessages/${messageId}/contacts`
      : '';

    if (type === SCHEDULED_MESSAGE_TYPES.EVENT_SMART_ACTION_MESSAGE) {
      url = `api/scheduledSmartActions/${messageId}/contacts`;
    }

    if (!url) {
      dispatch(addNotification(UPDATE_CONTACTS_SCHEDULED_MESSAGES_ERROR, 'Please refresh your page. This url is undefined', NOTIFICATION_STATUS.ERROR));
    }

    await axios.put(
      url,
      {
        sendTo,
        contacts,
      }
    );
    dispatch({
      type: UPDATE_CONTACTS_SCHEDULED_MESSAGES_SUCCESS,
    });
    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_CONTACTS_SCHEDULED_MESSAGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_CONTACTS_SCHEDULED_MESSAGES_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const removeContactsScheduledMessage = (messageId, contacts, doWhenTry, doWhenCatch) => async (dispatch) => {
  dispatch({
    type: REMOVE_CONTACTS_SCHEDULED_MESSAGES,
  });
  try {
    await axios.delete(
      `/api/scheduledMessages/${messageId}/contacts`,
      {
        data: {
          contacts,
        },
      }
    );
    dispatch({
      type: REMOVE_CONTACTS_SCHEDULED_MESSAGES_SUCCESS,
    });
    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(REMOVE_CONTACTS_SCHEDULED_MESSAGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: REMOVE_CONTACTS_SCHEDULED_MESSAGES_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setScheduledMessages = (scheduledMessages) => ({
  type: SET_SCHEDULED_MESSAGES,
  payload: scheduledMessages
});

export const setScheduledMessagesQuery = (query) => ({
  type: SET_SCHEDULED_MESSAGES_QUERY,
  payload: query
});

export const clearScheduledMessagesQueryFilter = () => ({
  type: CLEAR_SCHEDULED_MESSAGES_QUERY_FILTER,
});

export const setSelectedScheduledMessages = (selectedScheduledMessages) => ({
  type: SET_SELECTED_SCHEDULED_MESSAGES,
  payload: selectedScheduledMessages
});

export const setValuesFormSendText = (values) => ({
  type: SET_VALUES_FORM_SEND_TEXT,
  payload: values
});

export const sendTextMessage = (sendMessage, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_TEXT_MESSAGE,
    });
    const response = await axios.put('/api/contacts/sendmessage', { sendMessage });
    const { success } = response?.data || {};

    if (!success) {
      dispatch(addNotification(SEND_TEXT_MESSAGE_ERROR, 'Try again later', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SEND_TEXT_MESSAGE_ERROR,
      });
      return;
    }

    dispatch(addNotification(SEND_TEXT_MESSAGE_SUCCESS, 'Your text has been scheduled to send.', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: SEND_TEXT_MESSAGE_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(SEND_TEXT_MESSAGE_ERROR, message || errorMessage || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SEND_TEXT_MESSAGE_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

// CON-1621 — contexts limits the picker to template scopes that can
// actually resolve on this surface's send path. Omitted means the server
// returns contact scope only (fail closed).
export const getFollowUpMessages = (contexts = null) => async (dispatch) => {
  try {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES,
    });
    const { data } = await axios.post('/api/followupmessages/template-tag', contexts ? { contexts } : {}) || {};
    const { error } = data || {};

    if (error) {
      dispatch({
        type: GET_FOLLOW_UP_MESSAGES_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
      payload: data?.messages,
    });
  } catch (e) {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_ERROR,
    });
  }
};

export const replaceSystemGenMessage = (systemGenMessage, dynamicFieldsObj) => async (dispatch) => {
  try {
    dispatch({
      type: REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE,
    });
    const { data } = await axios.post('/api/contacts/replace-system-gen-message', {
      systemGenMessage,
      ...dynamicFieldsObj || {},
    }) || {};

    dispatch({
      type: REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE_SUCCESS,
      payload: data?.message,
    });
  } catch (e) {
    dispatch({
      type: REPLACE_SYSTEM_GEN_SCHEDULED_MESSAGE_ERROR,
    });
  }
};

export const clearFollowUpMessages = () => ({
  type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
});

export const setBackToScheduledMessagesList = (payload) => ({
  type: SET_BACK_TO_SCHEDULED_MESSAGES_LIST,
  payload,
});

export const clearBackToScheduledMessagesList = (clearAll = false) => ({
  type: SET_BACK_TO_SCHEDULED_MESSAGES_LIST,
  payload: !clearAll ? {
    scheduledMessages: [],
    query: {},
  } : false,
});

export const setScheduledMessageDetailsTab = (tabName) => async (dispatch) => {
  dispatch({
    type: SET_SCHEDULED_MESSAGE_DETAILS_TAB,
    payload: tabName
  });
};

export const setBackToScheduledMessageEdit = (payload) => ({
  type: SET_BACK_TO_SCHEDULED_MESSAGE_EDIT,
  payload,
});

export const getScheduledMessageContacts = (messageId, type, isSendTo = false, isOnlyTotalCount = false, hiddenUpdating = false) => async (dispatch, getState) => {
  dispatch({
    type: GET_SCHEDULED_MESSAGE_CONTACTS,
    payload: {
      isSendTo,
      isOnlyTotalCount,
      hiddenUpdating,
    }
  });
  try {
    const state = getState();
    const query = isSendTo
      ? state?.scheduledMessages?.sendTo?.query || {}
      : state?.scheduledMessages?.dontSendTo?.query || {};

    const params = isOnlyTotalCount ? {
      page: 1,
      pageSize: 1,
      sendTo: isSendTo,
    } : {
      page: query?.page,
      pageSize: query?.pageSize,
      q: query?.search ? query.search : undefined,
      sendTo: isSendTo,
      sort: query?.sort,
      failedReason: query?.failedReason || undefined,
    };

    let url = type === SCHEDULED_MESSAGE_TYPES.SCHEDULED_MESSAGE
      || type === SCHEDULED_MESSAGE_TYPES.GROUP_SMART_ACTION_MESSAGE
      || type === SCHEDULED_MESSAGE_TYPES.SCHEDULED_BIRTHDAY_MESSAGE
      ? `/api/scheduledMessages/${messageId}/contacts`
      : '';

    if (type === SCHEDULED_MESSAGE_TYPES.EVENT_SMART_ACTION_MESSAGE) {
      url = `api/scheduledSmartActions/${messageId}/contacts`;
    }

    if (!url && !hiddenUpdating) {
      dispatch(addNotification(GET_SCHEDULED_MESSAGE_CONTACTS_ERROR, 'Please refresh your page. This url is undefined', NOTIFICATION_STATUS.ERROR));
    }

    const response = await axios.get(url, { params });
    dispatch({
      type: GET_SCHEDULED_MESSAGE_CONTACTS_SUCCESS,
      payload: {
        contacts: response?.data || {},
        isSendTo,
        isOnlyTotalCount,
        hiddenUpdating,
      },
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    if (!hiddenUpdating) {
      dispatch(addNotification(GET_SCHEDULED_MESSAGE_CONTACTS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    }
    dispatch({
      type: GET_SCHEDULED_MESSAGE_CONTACTS_ERROR,
      payload: {
        isSendTo,
        isOnlyTotalCount,
        hiddenUpdating,
      }
    });
  }
};

export const clearScheduledMessageContacts = () => async (dispatch) => {
  dispatch({
    type: CLEAR_SCHEDULED_MESSAGE_CONTACTS,
  });
};

export const setSelectedContactsSendTo = (selectedContacts) => ({
  type: SET_SELECTED_CONTACTS_SEND_TO,
  payload: selectedContacts
});

export const setSelectedContactsDontSendTo = (selectedContacts) => ({
  type: SET_SELECTED_CONTACTS_DONT_SEND_TO,
  payload: selectedContacts
});

export const setContactsSendToQuery = (query) => ({
  type: SET_CONTACTS_SEND_TO_QUERY,
  payload: query
});

export const setContactsDontSendToQuery = (query) => ({
  type: SET_CONTACTS_DONT_SEND_TO_QUERY,
  payload: query
});

export const socketScheduledMessageSentInList = (message) => async (dispatch) => {
  dispatch({
    type: SOCKET_SCHEDULED_MESSAGE_SENT_LIST,
    payload: message,
  });
};

export const getScheduledMessageContactsSummary = (messageId, messageType) => async (dispatch) => {
  dispatch({ type: GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY });
  try {
    const url = messageType === SCHEDULED_MESSAGE_TYPES.EVENT_SMART_ACTION_MESSAGE
      ? `/api/scheduledSmartActions/${messageId}/contacts/summary`
      : `/api/scheduledMessages/${messageId}/contacts/summary`;
    const response = await axios.get(url);
    dispatch({
      type: GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY_SUCCESS,
      payload: response?.data || {},
    });
  } catch (e) {
    dispatch({ type: GET_SCHEDULED_MESSAGE_CONTACTS_SUMMARY_ERROR });
  }
};
